export default "__VITE_ASSET__BjsrPvjy__"